import { render } from "./ChangeProfile.vue?vue&type=template&id=ce6e252e&scoped=true"
import script from "./ChangeProfile.vue?vue&type=script&lang=js"
export * from "./ChangeProfile.vue?vue&type=script&lang=js"

import "./ChangeProfile.vue?vue&type=style&index=0&id=ce6e252e&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6e252e"]])

export default __exports__